<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Movimiento Inventario físico
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Movimiento Inventario físico</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader'>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>

        <button type="button" mdbBtn color="info" (click)="showModalAdd()" mdbWavesEffect size="sm">
          Crear Doc.
        </button>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaInicio"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaFin"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado" formControlName="estado"></mdb-select>
            <label>Estado</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9999" required #rutcliente
              formControlName="nroDoc" onlyNumbers />
            <label for="rutcliente">Nro. Doc.</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="info" mdbWavesEffect (click)="showModalConsulta()">
            <mdb-icon fas icon="eye"></mdb-icon>
          </button>
          <!-- <h6 class="text-info" style="display: contents">Algun dato del Doc.</h6> -->
        </div>
      </div>




    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 25%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page"
          (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>


<section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;">
  <div class="card mb-2 wow" style="z-index: 1;width: 100%;">
    <div class="card-body" *ngIf="listaMovimientos">

      <!-- <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner> -->

      <div class="">
        <table class="table table-striped table-hover table-sm align-middle" mdbTableEditor mdbTable mdbTableScroll
          scrollX="true" scrolly="true" maxHeight="500" striped="true" bordered="true" stickyHeaderBgColor="#E0E0E0"
          stickyHeaderTextColor="#212529" stickyHeader="true">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Resumen</th>
              <th scope="col">Nro. Doc.</th>
              <th scope="col">Fecha</th>
              <th scope="col">Bodega</th>
              <th scope="col">Estado</th>
              <th scope="col">Toma inventario</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colspan="100%" style="text-align: center" *ngIf="listaMovimientos?.length === 0">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let mov of listaMovimientos">
              <td>
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="loadModalConsulta(mov)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
              <td>{{mov.codigo}}</td>
              <td>{{mov.fecha_creacion | fecha}}</td>
              <td>{{mov.bodega_nombre}}</td>
              <td>
                <mdb-badge *ngIf="mov.estado_inventario_codigo === 1" pill="true" info="true">Pendiente</mdb-badge>
                <mdb-badge *ngIf="mov.estado_inventario_codigo === 2" pill="true" warning="true">Por procesar
                </mdb-badge>
                <mdb-badge *ngIf="mov.estado_inventario_codigo === 3" pill="true" success="true">Procesado</mdb-badge>
                <mdb-badge *ngIf="mov.estado_inventario_codigo === 4" pill="true" danger="true">Eliminado</mdb-badge>
                <mdb-badge *ngIf="mov.estado_inventario_codigo === 5" pill="true" default="true">Sin Efecto</mdb-badge>
              </td>
              <td>
                <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                  (click)="loadModalTomaInventario(mov)" *ngIf="mov.additionalData.allowTomaInvenario">
                  Ingresar
                </button>
              </td>
              <td>
                <!-- <ng-container *ngIf="mov.estado_inventario_codigo === 1"></ng-container> -->
                <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                  data-toggle="modal" data-target="#basicExamplex" (click)="loadModalEdit(mov)" mdbTooltip="Editar Toma"
                  placement="right" disabled="true" [ngClass]="{
                      'toma-inventario__d-inline-block': mov.additionalData.allowEditar,
                      'toma-inventario__d-invisible': !mov.additionalData.allowEditar
                    }" [disabled]="!mov.additionalData.allowEditar">
                  <mdb-icon fas icon="pen"></mdb-icon>
                </button>

                <!-- <ng-container *ngIf="mov.estado_inventario_codigo === 1"></ng-container> -->
                <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect mdbTooltip="Eliminar"
                  placement="right" (click)="eliminar(mov)" [ngClass]="{
                      'toma-inventario__d-inline-block': mov.additionalData.allowEliminar,
                      'toma-inventario__d-invisible': !mov.additionalData.allowEliminar
                    }" [disabled]="!mov.additionalData.allowEliminar">
                  <mdb-icon fas icon="trash"></mdb-icon>
                </button>

                <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                  data-toggle="modal" data-target="#basicExamplex" (click)="loadModalEditarAjuste(mov)"
                  mdbTooltip="Editar Ajuste" placement="right" disabled="true" [ngClass]="{
                    'toma-inventario__d-inline-block': mov.additionalData.allowRealizarAjuste,
                    'toma-inventario__d-invisible': !mov.additionalData.allowRealizarAjuste
                  }" [disabled]="!mov.additionalData.allowRealizarAjuste">
                  <mdb-icon fas icon="pen"></mdb-icon>
                </button>

                <!-- <ng-container *ngIf="mov.estado_inventario_codigo === 1"></ng-container> -->
                <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                  (click)="loadModalRealizarAjuste(mov)" *ngIf="mov.additionalData.allowRealizarAjuste">
                  Realizar ajuste
                </button>


              </td>
            </tr>
            <tr>
              <td colspan="100%" style="text-align: center">
                <div class="row pb-1 pt-1" id="spinnerX">
                  <div class="col-md-12 p-4">
                    <ngx-spinner bdColor="" bdoOpacity="0.9" size="default" color="#581f87" type="ball-pulse-sync"
                      [fullScreen]="false">
                    </ngx-spinner>

                  </div>
                </div>
              </td>

            </tr>
          </tbody>
          <tfoot *ngIf="listaMovimientos?.length > 0">
            <tr>
              <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
              <th colspan="12">
                {{ PagPosActual }} de {{ totalPagPos }} ({{
                totalRegistrosPos
                }}
                registros)
              </th>
            </tr>
          </tfoot>
          <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listaMovimientos?.length > 0"></app-pagination> -->
        </table>
      </div>
    </div>
  </div>
</section>


<!-- MODAL tomaInventario/CREAR DOC. -->
<app-modal-add-edit (onSuccess)="buscar(1)"></app-modal-add-edit>

<!-- MODAL Ingresar Doc. -->
<app-modal-toma-inventario (onSuccess)="buscar(1)"></app-modal-toma-inventario>

<!-- MODAL Ajuste de inventario -->
<app-modal-realizar-ajuste (onSuccess)="buscar(1)"></app-modal-realizar-ajuste>

<!-- MODAL Ajuste de inventario -->
<app-modal-editar-ajuste (onSuccess)="buscar(1)"></app-modal-editar-ajuste>

<!-- MODAL Consulta movimiento -->
<app-modal-consulta></app-modal-consulta>

<!-- MODAL Eliminar movimiento -->
<app-modal-confirm title="Eliminar movimiento" contentText="¿Desea eliminar el registro?">
</app-modal-confirm>
